import axios, { AxiosError, AxiosResponse } from 'axios'
import { ApiError, IApiErrorResponse } from '@/models'

const isProduction = process.env.NODE_ENV === 'production'
const baseURL = isProduction
    ? 'https://backend.kurier.umami.pl'
    : 'https://backend.kurier.umami.pl'
const api = axios.create({ baseURL, withCredentials: false })

api.interceptors.response.use(
    (response: AxiosResponse): AxiosResponse => response,
    (error: AxiosError): Promise<IApiErrorResponse> => {
        const apiError = new ApiError(error)

        // @see: https://github.com/axios/axios/issues/960
        return Promise.reject(apiError.response)
    }
)

export { api }
